var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3284 14.5923L4.3573 8.43801H13.7176L1.3284 14.5923ZM1.33001 1.39398L13.7162 7.54495L4.3573 7.54673L1.33001 1.39398ZM16 7.99393C16.0002 7.81888 15.9077 7.65987 15.7637 7.58771L0.569011 0.0396987C0.36652 -0.0616333 0.127561 0.0376942 0.0358862 0.261738C-0.0162979 0.389127 -0.0112609 0.535891 0.0489826 0.658603L3.665 8.00016L0.0489826 15.3419C-0.0332225 15.5096 -0.00985051 15.7168 0.107413 15.8568L0.118897 15.8693C0.237168 16.0003 0.416488 16.0366 0.569011 15.9609L15.7622 8.39859C15.9065 8.3271 15.9994 8.16875 16 7.99393Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendArrow);
export default __webpack_public_path__ + "static/media/send-arrow.b8b3c5a003b52d78d149f6515f584de7.svg";
export { ForwardRef as ReactComponent };